export const isNumber = (value: unknown): value is number => typeof value === 'number' && !isNaN(value);
